import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as store from '../../reducers/store';
import {
  findMaybeOneReviewable,
  getFormsFromFormSets,
} from '../../utils/formSet';
import { getReviewPath } from '../../utils/form';

export const useReviewRedirect = (authenticationCode: string) => {
  const history = useHistory();
  const forms = useSelector((store: store.All) =>
    getFormsFromFormSets(store.formSets),
  );
  const reviewForm = findMaybeOneReviewable(forms);
  const multi = useSelector((store: store.All) => store.multiFormSet);
  const allowReview =
    new URLSearchParams(history.location.search).get('allowReview') === 'true';
  useEffect(() => {
    if (allowReview && reviewForm?.id) {
      history.push(
        getReviewPath({
          authenticationCode,
          formSetId: reviewForm.previsitFormSetId,
          formId: reviewForm.id,
          multi,
        }),
      );
    }
  }, [
    reviewForm?.id,
    reviewForm?.previsitFormSetId,
    allowReview,
    authenticationCode,
    history,
    multi,
  ]);
};
